const StudyLevelEnum=[
    {value:'doctorado' ,label:'Doctorado'},
    {value:'especializacion' ,label:'Especialización'},
    {value:'maestria' ,label:'Maestría'},
    {value:'noespecificado' ,label:'No especificado'},
    {value:'noestudio' ,label:'No hizo estudios'},
    {value:'posdoc' ,label:'Posdoctorado'},
    {value:'terciario' ,label:'Terciario'},
    {value:'universitario' ,label:'Universitario'}
  ]

export default StudyLevelEnum;